var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
// Material ui Imports
import { Avatar, Button, IconButton, ListItemButton, ListItemIcon, ListItemText, Tooltip, useMediaQuery, } from "@mui/material";
import { styled } from "@mui/system";
// Custom components imports (and hooks and helpers)
// Media imports
//---------------------------------------------------------------------------------------------------
// ## MUI STYLED ##
// Styled primary and secondary buttons type
var StyledButton = styled(Button)(function () { return ({
    padding: "5px 30px",
    borderRadius: 10,
}); });
// Styling for the icon button type
var StyledIconButton = styled(IconButton)(function () { return ({
    borderRadius: 20,
}); });
// Styling for the avatar button type
var StyledAvatar = styled(Avatar)(function () { return ({
    border: "none",
}); });
//---------------------------------------------------------------------------------------------------
// ## COMPONENTS ##
// VTButton use for web development to replace the material ui button
export default function VTButton(props) {
    var _a = props.collapse, collapse = _a === void 0 ? 600 : _a, toolTipOptions = props.toolTipOptions;
    var matches = useMediaQuery("(max-width:".concat(collapse, "px)"));
    //-------------------------------------------------------------------------------------------------
    // ## Render ##
    return (_jsx(Tooltip
    // open={Boolean(toolTipOptions)}
    , __assign({ 
        // open={Boolean(toolTipOptions)}
        disableHoverListener: !Boolean(toolTipOptions === null || toolTipOptions === void 0 ? void 0 : toolTipOptions.toolTipText), placement: toolTipOptions === null || toolTipOptions === void 0 ? void 0 : toolTipOptions.toolTipPlacement, arrow: Boolean(toolTipOptions === null || toolTipOptions === void 0 ? void 0 : toolTipOptions.arrow), title: toolTipOptions === null || toolTipOptions === void 0 ? void 0 : toolTipOptions.toolTipText }, { children: GetButtonByType(props) })));
}
function GetButtonByType(_a) {
    var onClick = _a.onClick, startIcon = _a.startIcon, endIcon = _a.endIcon, to = _a.to, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.type, type = _c === void 0 ? "primary" : _c, children = _a.children, _d = _a.disableElevation, disableElevation = _d === void 0 ? true : _d, color = _a.color, sx = _a.sx, image = _a.image, _e = _a.selected, selected = _e === void 0 ? false : _e, onSubmitButtonType = _a.onSubmitButtonType, _f = _a.fullWidth, fullWidth = _f === void 0 ? false : _f;
    // Icon type buttons
    if (type === "icon") {
        return (_jsxs(StyledIconButton, __assign({ onMouseDown: function (e) {
                e.stopPropagation();
            }, onMouseUp: function (e) {
                e.stopPropagation();
            }, onClick: !disabled ? onClick : undefined, 
            // @ts-ignore
            to: to, component: to ? Link : "button", disabled: disabled, sx: sx, color: color, disableElevation: disableElevation, fullWidth: fullWidth }, { children: [startIcon, children, endIcon] })));
    }
    //-------------------------------------------------------------------------------------------------
    // Avatar buttons
    else if (type === "avatar") {
        return (_jsx(StyledAvatar, __assign({ onMouseDown: function (e) {
                e.stopPropagation();
            }, onMouseUp: function (e) {
                e.stopPropagation();
            }, 
            // @ts-ignore
            onClick: !disabled ? onClick : undefined, 
            // @ts-ignore
            to: to, component: to ? Link : "button", disabled: disabled, sx: sx, color: color, disableElevation: disableElevation, fullWidth: fullWidth }, { children: children })));
    }
    else if (type === "underline") {
        return (_jsxs(StyledButton, __assign({ onMouseDown: function (e) {
                e.stopPropagation();
            }, onMouseUp: function (e) {
                e.stopPropagation();
            }, onClick: !disabled ? onClick : undefined, 
            // @ts-ignore
            to: to, component: to ? Link : "button", disabled: disabled, sx: __assign({ color: "white", borderBottom: "3px solid rgb(150, 28, 255)", background: "none", borderRadius: "0px" }, sx), disableElevation: disableElevation, variant: "text", color: "primary", fullWidth: fullWidth }, { children: [startIcon, children, endIcon] })));
    }
    //-------------------------------------------------------------------------------------------------
    // List buttons
    else if (type === "list") {
        // if (matches && (startIcon || endIcon)) {
        //     return (
        //         <div
        //             // @ts-ignore
        //             onClick={onClick}
        //             // @ts-ignore
        //             to={to}
        //             component={to ? Link : "button"}
        //             disableElevation={disableElevation}
        //         >
        //             <ListItemButton
        //                 selected={selected}
        //                 disabled={disabled}
        //                 color={color}
        //                 sx={{
        //                         opacity: "0.3",
        //                         background: "red",
        //                         ...sx,
        //                     // "&.MuiListItemButton-root": {
        //                     //   "& .Mui-selected": { background: "red" },
        //                     // },
        //                 }}
        //                 alignItems={"center"}
        //             >
        //                 {startIcon && (
        //                     <ListItemIcon style={{ width: "100%" }}>
        //                         {startIcon}
        //                     </ListItemIcon>
        //                 )}
        //                 {endIcon && (
        //                     <ListItemIcon style={{ width: "100%" }}>
        //                         {endIcon}
        //                     </ListItemIcon>
        //                 )}
        //             </ListItemButton>
        //         </div>
        //     );
        // } else {
        return (_jsx("div", __assign({ onMouseDown: function (e) {
                e.stopPropagation();
            }, onMouseUp: function (e) {
                e.stopPropagation();
            }, 
            // @ts-ignore
            onClick: !disabled ? onClick : undefined, 
            // @ts-ignore
            to: to, component: to ? Link : "button", disableElevation: disableElevation }, { children: _jsxs(ListItemButton, __assign({ selected: selected, disabled: disabled, color: color, sx: __assign({ "&.Mui-selected": {
                        background: "#555",
                        ":hover": {
                            background: "#555",
                        },
                    } }, sx) }, { children: [(startIcon || endIcon) && _jsx(ListItemIcon, __assign({ style: { marginRight: -10 } }, { children: startIcon })), _jsx(ListItemText, { children: children }), (startIcon || endIcon) && _jsx(ListItemIcon, __assign({ style: { marginLeft: -10 } }, { children: endIcon }))] })) })));
        // }
    }
    //-------------------------------------------------------------------------------------------------
    // Primary and Secondary type buttons
    else {
        // if (startIcon || endIcon) {
        return (_jsxs(StyledButton, __assign({ onMouseDown: function (e) {
                e.stopPropagation();
            }, onMouseUp: function (e) {
                e.stopPropagation();
            }, type: onSubmitButtonType ? "submit" : "button", onClick: !disabled ? onClick : undefined, 
            // @ts-ignore
            to: to, component: to ? Link : "button", disabled: disabled, sx: sx, disableElevation: disableElevation, variant: type === "secondary" ? "outlined" : "contained", color: color, fullWidth: fullWidth }, { children: [startIcon, children, endIcon] })));
        //     } else
        //         return (
        //             <StyledButton
        //                 type={onSubmitButtonType ? "submit" : "button"}
        //                 onClick={!disabled ? onClick : undefined}
        //                 // @ts-ignore
        //                 to={to}
        //                 component={to ? Link : "button"}
        //                 disabled={disabled}
        //                 startIcon={startIcon}
        //                 endIcon={endIcon}
        //                 sx={sx}
        //                 disableElevation={disableElevation}
        //                 variant={type === "secondary" ? "outlined" : "contained"}
        //                 color={color}
        //                 fullWidth={fullWidth}
        //             >
        //                 {children}
        //             </StyledButton>
        //         );
    }
}
